module.exports = __webpack_public_path__ + "static/media/quoter-clinics.097870e1.svg";